import { ActiveFacet, CustomSearchResults, SearchHistoryItem } from '@search/const';
import { StateUtils } from '@spartacus/core';

export const SEARCH_FEATURE = 'search';
export const FACETS_TOTAL_RESULTS = '[Search] Facets Total Results';
export const SEARCH_SUGGESTIONS = '[Search] Search Suggestions';

export interface SearchState {
  totalResults: StateUtils.LoaderState<number>;
  activeFacets: ActiveFacet[];
  selectedFacets: ActiveFacet[];
  searchSuggestions: StateUtils.LoaderState<CustomSearchResults>;
  searchHistory: SearchHistoryItem[];
}

export interface StateWithSearch {
  [SEARCH_FEATURE]: SearchState;
}
